// extracted by mini-css-extract-plugin
module.exports = {"container":"DeliveryOptionsList_container___gbjJ"};